import { z } from 'zod';
import {
  PAGINATION_PAGE_SIZE_DEFAULT,
  PAGINATION_SORT_DIRECTION,
} from '~/constants';

import { ValidUuidOrNotSetSchema } from '@vestigas/utils';

import {
  SUPPLIER_REQUEST_ORDER_BY,
  SUPPLIER_REQUEST_STATE,
} from '../constants';
import {
  zodCompanyAccountRefSchema,
  zodCompanyRefSchema,
  zodPriorRejectionRefSchema,
  zodResolvedCompanyRefSchema,
  zodSubmittedSupplierInfoSchema,
} from '../validations';

export const zodSupplierRequestsQueryParamsSchema = z.object({
  limit: z
    .number()
    .gte(1)
    .max(500)
    .optional()
    .prefault(PAGINATION_PAGE_SIZE_DEFAULT)
    .catch(PAGINATION_PAGE_SIZE_DEFAULT),
  offset: z.number().nonnegative().optional().prefault(0).catch(0),
  orderBy: z
    .enum(SUPPLIER_REQUEST_ORDER_BY)
    .optional()
    .prefault('requested_at')
    .catch('requested_at'),
  requestingCompanyAccountId: ValidUuidOrNotSetSchema,
  requestingCompanyId: ValidUuidOrNotSetSchema,
  searchString: z.string().trim().optional(),
  sortOrder: z
    .enum(PAGINATION_SORT_DIRECTION)
    .optional()
    .prefault('DESC')
    .catch('DESC'),
  state: z.enum(SUPPLIER_REQUEST_STATE).nullish(),
});

export const zodSupplierRequestListItemSchema = z.object({
  createdAt: z.iso.datetime({ offset: true }),
  id: z.uuid(),
  potentialDuplicateCompanyId: z.uuid().nullish(),
  priorRejection: zodPriorRejectionRefSchema.nullish(),
  rejectionReason: z.string().nullish(),
  requestingCompany: zodCompanyRefSchema,
  requestingCompanyAccount: zodCompanyAccountRefSchema,
  resolvedCompany: zodResolvedCompanyRefSchema.nullish(),
  state: z.enum(SUPPLIER_REQUEST_STATE),
  submitted: zodSubmittedSupplierInfoSchema,
});

export const zodSupplierRequestListResponseSchema = z.object({
  data: z.array(zodSupplierRequestListItemSchema),
  hasNextPage: z.boolean(),
  limit: z.number().gte(1).optional().prefault(PAGINATION_PAGE_SIZE_DEFAULT),
  offset: z.number().nonnegative().optional().prefault(0),
  paginatedCount: z.number().nonnegative(),
  totalCount: z.number().nonnegative(),
});
